import { BaseApiModel } from './BaseApiModel';

export class Address extends BaseApiModel {
  public complement: string;
  public neighborhood: string;
  public number: string;
  public street: string;
  public zipcode: string;
};
